import styled from "styled-components";

export const CustomCursorIconContainer = styled.svg`
  overflow: visible;

  path {
    visibility: hidden;
  }
`;
